Drupal.behaviors.tabs = {
  attach: function (context) {
    var tabHeaders = document.querySelectorAll('.tab-header', context);
    for (i = 0; i < tabHeaders.length; i++) {
      tabHeaders[i].addEventListener('click', function (e) {
        var tabId = e.target.dataset.tabId;
        tabHeaders[tabId].scrollIntoView(true);
      })
    }
  },
};
